"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

var _styles = require("../shared/styles");

var _SucessIcon = require("../../../shared/SucessIcon");

var _ref2 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.IconWrapper, {}, void 0, (0, _jsx2["default"])(_SucessIcon.SuccessIcon, {}));

var _ref3 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.TitleText, {
  color: "pink"
}, void 0, "Sucesso! Recebemos os seus dados de acesso");

var _ref4 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.InfoText, {}, void 0, "Estamos carregando os dados do seu perfil");

var Success = function Success(_ref) {
  var onContinue = _ref.onContinue;
  if (process.browser) setTimeout(onContinue, 1500);
  return (0, _jsx2["default"])(_Row["default"], {
    flexDirection: "column"
  }, void 0, _ref2, _ref3, _ref4, (0, _jsx2["default"])(_styles.CTAButton, {
    fluid: true,
    active: true,
    mt: 4,
    onClick: onContinue
  }, void 0, "Continuar"));
};

Success.propTypes = {
  onContinue: _propTypes["default"].func.isRequired
};
var _default = Success;
exports["default"] = _default;